import { createContext, useState } from 'react';
import api from 'services/api';

export const EntregasContext = createContext();

export const EntregasProvider = ({ children }) => {
  const [getLoading, setGetLoading] = useState(false);
  const [entregas, setEntregas] = useState({
    data: [],
    colunas: [],
    order: { field: 'dtemissao', sort: 'desc' },
    filter: {},
    page: 0,
    size: 10,
  });

  const getEntregas = async (payload) => {
    try {
      setGetLoading(true);
      const { data } = await api.post('/Grid', {
        filter: entregas?.filter,
        page: entregas?.page,
        size: entregas?.size,
        order: entregas?.order,
        ...payload,
      });
      setEntregas((prev) => ({ ...prev, ...data, ...payload }));
    } catch (error) {
    } finally {
      setGetLoading(false);
    }
  };

  return (
    <EntregasContext.Provider
      value={{
        entregas,
        getLoading,
        getEntregas,
      }}
    >
      {children}
    </EntregasContext.Provider>
  );
};
